export default __webpack_public_path__ + "static/media/watchops-logo-header.20b1a758.png";